import { getGuestAuthIssueCopy } from '../lib/guestCopy.js';

function StripIcon({ variant }) {
  if (variant === 'user') {
    return (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" strokeLinecap="round" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    );
  }
  if (variant === 'alert') {
    return (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M12 9v4M12 17h.01" strokeLinecap="round" />
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 animate-spin" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M21 12a9 9 0 1 1-6.22-8.56" strokeLinecap="round" />
    </svg>
  );
}

export default function AccountStrip({
  ready,
  barUser,
  authEmail,
  reason,
  profileError,
  onOpen,
  onRetry,
}) {
  const hasIssue = Boolean(ready && !barUser);
  const authIssue = hasIssue && reason ? getGuestAuthIssueCopy(reason) : null;
  const devDetail = import.meta.env.DEV && profileError ? profileError : null;

  let statusLine = 'Connexion en cours…';
  let iconVariant = 'loading';
  if (ready && barUser) {
    statusLine = barUser.is_guest ? `Invité · ${barUser.username}` : barUser.username;
    iconVariant = 'user';
  } else if (ready && !barUser) {
    statusLine = authIssue?.title ?? 'Compte indisponible';
    iconVariant = 'alert';
  }

  return (
    <div className="mt-3 rounded-2xl border border-border bg-bg-card p-3.5">
      <div className="flex items-start gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border bg-bg-soft ${
            iconVariant === 'alert' ? 'text-amber-300' : 'text-white/80'
          }`}
        >
          <StripIcon variant={iconVariant} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-white/45">
            Compte
          </p>
          <p className="mt-1 text-sm font-medium leading-snug text-white">{statusLine}</p>
          {authEmail ? (
            <p className="mt-0.5 truncate text-xs text-white/50">{authEmail}</p>
          ) : null}
          {hasIssue && authIssue ? (
            <p className="mt-2 text-[11px] leading-relaxed text-amber-200/85">{authIssue.body}</p>
          ) : null}
          {devDetail ? (
            <p className="mt-2 rounded-lg bg-black/30 px-2 py-1.5 font-mono text-[10px] text-amber-50/85">
              Dev : {devDetail}
            </p>
          ) : null}
          {ready && barUser ? (
            <p className="mt-2 text-[11px] leading-relaxed text-white/45">
              Tu peux tout faire en invité. Ajoute ton e-mail seulement pour retrouver tes points sur
              un autre appareil.
            </p>
          ) : null}
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          className="btn-primary min-h-[44px] flex-1 px-3 py-2.5 text-xs sm:flex-none"
          onClick={onOpen}
        >
          {barUser ? 'Compte et pseudo' : 'Connexion ou invité'}
        </button>
        {hasIssue ? (
          <button
            type="button"
            className="btn-secondary min-h-[44px] px-3 py-2.5 text-xs"
            onClick={() => void onRetry?.()}
          >
            Réessayer
          </button>
        ) : null}
      </div>
    </div>
  );
}
